export function sanitizeInput(input: any) {
  if (typeof input === 'string') {
    // Replace special characters with their HTML entity equivalents
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/`/g, '&#96;')
  }
  if (typeof input === 'function') {
    return null
  }
  return input
}

export function sanitizeObject(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map((item) => sanitizeObject(item))
  }

  if (typeof obj === 'object' && obj !== null) {
    const sanitizedObj: Record<string, any> = {}

    Object.entries(obj).forEach(([key, value]) => {
      sanitizedObj[key] = sanitizeObject(value)
    })

    return sanitizedObj
  }

  return sanitizeInput(obj)
}

export function sanitizeHeaderString(value: string | string[] | null | undefined) {
  if (Array.isArray(value)) {
    return value[0]
  }
  return value ?? undefined
}

export const sanitizeBaseUrl = (host: string, useHttp = false) => {
  const targetProtocol = useHttp ? 'http' : 'https'
  const value = String(host)
  if (value.startsWith('http://')) {
    return value.replace('http', targetProtocol)
  }
  if (value.startsWith('https://')) {
    return value.replace('https', targetProtocol)
  }
  if (!value.startsWith(`${targetProtocol}://`)) {
    return `${targetProtocol}://${value}`
  }
  return value
}

export const sanitizeRedirectPathToUrl = (
  redirectPath?: string,
  safeBaseUrl?: URL
): URL | undefined => {
  if (!redirectPath || !safeBaseUrl) {
    return undefined
  }
  const decodedRedirect = decodeURIComponent(redirectPath)

  let url: URL
  try {
    url = new URL(decodedRedirect, safeBaseUrl)
  } catch (e) {
    return undefined
  }

  if (url.origin === safeBaseUrl.origin) {
    return url
  }

  return undefined
}
